import API from '../app.api';

const hydrateConfigHeader = (optHeader, headers = {}) => {
    for (let key in optHeader) {
        if (optHeader[key] != null) {
            headers[key] = headers[key];
        }
    }
    return headers;
};

export const getSecurityGroups = async (entityId, body) => {
    const res = await API.get(`/api/v1/admin/drive/security-group/keys`, {
        headers: hydrateConfigHeader({
            'amc-entity-id': entityId || null
        }),
    });
    const d = res.data;
    return d;
};

export const getDrivePermissions = async (entityId, userId) => {
    const res = await API.get(`/api/v1/admin/user/${userId}/folder/access`, {
        headers: hydrateConfigHeader({
            'amc-entity-id': entityId || null
        }),
    });
    const d = res.data;
    return d;
};

export const getReportingPermissions = async (entityId, userId) => {
    const res = await API.get(`/api/v1/federated/bo/report-permission/user/${userId}`, {
        headers: hydrateConfigHeader({
            'amc-entity-id': entityId || null
        }),
    });
    const d = res.data;
    return d;
};


export const setDrivePermission = async (entityId, userId, permissions) => {
    const res = await API.put(`/api/v1/admin/user/${userId}/folder/access`, permissions, {
        headers: hydrateConfigHeader({
            'amc-entity-id': entityId || null
        }),
    });
    const d = res.data;
    return d;
};


export const setPortalPermission = async (entityId, userId, permissions) => {
    const res = await API.put(`/api/v1/admin/user/${userId}/permission`, permissions, {
        headers: hydrateConfigHeader({
            'amc-entity-id': entityId || null
        }),
    });
    const d = res.data;
    return d;
};

export const getPortalPermission = async (entityId, userId) => {
    const res = await API.get(`/api/v1/admin/user/${userId}/permission`, {
        headers: hydrateConfigHeader({
            'amc-entity-id': entityId || null
        }),
    });
    return res.data;
};

export const setReportingPermissions = async (entityId, permissionId, permissions) => {
    const res = await API.put(`/api/v1/federated/bo/report-permission/${permissionId}`, permissions, {
        headers: hydrateConfigHeader({
            'amc-entity-id': entityId || null
        }),
    });
    const d = res.data;
    return d;
};